import { cloneElement, useState } from 'react';
import {
  Menu,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CardAction from '../../../../components/card/CardAction';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './DropdownAction.scss';

const defaultProps = {
  menuItems: null,
};

const DropdownAction = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { menuItems } = mergedProps;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CardAction
        icon={<MoreHorizIcon aria-hidden='false' />}
        label=''
        actionHandler={(e) => {
          handleClick(e);
        }}
        className='dropdown-action'
        data-test='dropdown-more-action'
        tabIndex={0}
        aria-hidden='false'
      />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className='lesson-detail-dropdown-menu'
        tabIndex={0}
      >
        {menuItems.map((item) => (
          cloneElement(
            item,
            {
              onClick: handleClose,
            },
          )
        ))}
      </Menu>
    </>
  );
};

export default DropdownAction;
